export const RaterCreditTier = {
  hoCreditPriorClaimTierStepCode: '16C',
  dp3CreditPriorClaimTierStepCode: '16C' // for discussion
};